import React from 'react';
import styled from 'styled-components';

import { Typography } from '~lib/frontend/design-system/components/Typography';

interface PriceItem {
	duration: string;
	amount: string;
}

interface PriceTableProps {
	items: PriceItem[];
}

const PriceTable: React.FC<PriceTableProps> = ({ items }) => (
	<>
		{items.map((item, index) => (
			<PriceRow key={index}>
				<PriceCell>
					<Typography $type={'Body.Small'} $color={'textOnSurfaceBackground'}>
						{item.duration}
					</Typography>
				</PriceCell>
				<PriceCell>
					<Typography $type={'Body.XSmall'} $color={'textOnSurfaceBackgroundMuted'}>
						{'from'}
					</Typography>
					<Typography
						$type={'Body.XLarge'}
						$marginLeft={'extraSmall'}
						$bold
						$color={'textOnSurfaceBackground'}
					>
						{item.amount}
					</Typography>
				</PriceCell>
			</PriceRow>
		))}
	</>
);

const PriceRow = styled.div`
	display: flex;
	justify-content: space-between;
	margin-bottom: ${p => p.theme.spacing.large};
	align-items: baseline;
`;

const PriceCell = styled.div`
	display: flex;
	align-items: baseline;
`;

export default PriceTable;
